import { registerFirestoreDocumentConverter } from "@/firestore/myFreeReads"
import { dexieFirestoreDocument, FirestoreDocument } from "@/types/firestoreDocument"
import { Timestamp } from "firebase/firestore"
import { z } from "zod"
import { RecurrencePeriod } from "@/types/recurrence"

export type AbsenceRequestStatus = "pending" | "validated" | "validated_but_to_justify" | "rejected" | "canceled"

export interface AbsenceRequest extends FirestoreDocument {
   young_id: string
   from: Date
   to: Date
   reason: string
   justification_doc?: string
   status: AbsenceRequestStatus
   admin_comment: string
   attendance_event_id?: string

   // From version 2
   is_recurring?: boolean
   recurring_period?: RecurrencePeriod
   recurring_end_date?: Date
   recurring_group?: string

}

export const absenceRequestSchema = z.object({
   young_id: z.string(),
   from: z.date({
      errorMap: (issue) => {
         if (issue.code === "invalid_date") {
            return { message: "La date de début est invalide" }
         }
         return { message: "La date de début est requise" }
      },
   }),
   to: z.date({
      errorMap: (issue) => {
         if (issue.code === "invalid_date") {
            return { message: "La date de fin est invalide" }
         }
         return { message: "La date de fin est requise" }
      },
   }),
   reason: z.string().min(1, "La raison est requise"),
   justification_doc: z.string().optional(),
   status: z
      .enum(["pending", "validated", "validated_but_to_justify", "rejected"])
      .default("pending"),
   admin_comment: z.string().default(""),

   attendance_event_id: z.string().optional(),

   // From version 2
   is_recurring: z.boolean().optional(),
   recurring_period: z.enum(["everyday", "everyweek", "everymonth"]).optional(),
   recurring_end_date: z.date().optional(),
   recurring_group: z.string().optional(),
})

export const collectionName = "absence_requests"

export const dexieAbsenceRequest = dexieFirestoreDocument + ", recurring_end_date, young_id"

export const init = () =>
   registerFirestoreDocumentConverter<AbsenceRequest>(collectionName, (data) => {
      const { from, to, recurring_end_date, ...rest } = data
      return {
         ...rest,
         from: (from as any as Timestamp)?.toDate(),
         to: (to as any as Timestamp)?.toDate(),
         recurring_end_date: (recurring_end_date as any as Timestamp)?.toDate(),
      }
   })
